const MayrLogo = ({ className = "", height = 32 }) => {
  const aspectRatio = 800 / 300;
  const width = height * aspectRatio;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 800 300"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Mayr Technologies"
    >
      <defs>
        <linearGradient id="metal" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#d9d9d9" />
          <stop offset="50%" stopColor="#7a7a7a" />
          <stop offset="100%" stopColor="#f5f5f5" />
        </linearGradient>
        <linearGradient id="blue" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00c6ff" />
          <stop offset="100%" stopColor="#0072ff" />
        </linearGradient>
      </defs>

      {/* Icon */}
      <g transform="translate(80,40)">
        <path d="M0 120 L40 0 L80 120 L60 120 L40 50 L20 120 Z" fill="url(#metal)" />
        <path d="M60 120 C120 80 140 40 180 0" stroke="url(#blue)" strokeWidth="12" fill="none" />
      </g>

      {/* Text */}
      <text x="260" y="140" fontFamily="'Outfit', Arial, Helvetica, sans-serif" fontSize="60" fontWeight="bold" fill="url(#metal)">
        MAYR
      </text>
      <text x="260" y="190" fontFamily="'Outfit', Arial, Helvetica, sans-serif" fontSize="24" letterSpacing="6" fill="#cccccc">
        TECHNOLOGIES
      </text>
    </svg>
  );
};

export default MayrLogo;
